export default __webpack_public_path__ + "slices/main/assets/public/media/ca_homepage_staggered.e647a0ebc393252efbb76c6c7ef78eb8.png";